import useWindowPositionTop from 'hooks/useWindowPositionTop';
import heroImage from 'assets/img/background.jpg';
// import logo from 'assets/img/logo.png';
// import titleImage from 'assets/img/I_speak.png'
// import tutorImage from 'assets/img/tutor-image.jpg'
// import img from 'assets/img/IMG_9314-1.jpg'
// import celt from '@/src/assets/img/tefl-tesol-celt.jpg'
// import ct from '@/src/assets/img/tefl-tesol-ct.jpg'
// import importanceImage from 'assets/img/ExclamationMark.jpg'

export default function HomePage () {
    useWindowPositionTop();
    return (
        <main className="main">
            <Hero/>
        </main>
    )
}

export function Hero() {
    return (
        <>
            <section className='hero'>
                <h1>Курс подготовки к ЕГЭ по английскому языку</h1>
                <div className="hero-background">
                    <img src={heroImage} alt="RostEnglish" className="hero-image" />
                </div>
                <p>🎯 Готовимся к ЕГЭ по английскому языку вместе — уверенно и эффективно!</p>
            </section>
            <section>
                <h2 className="price-title">Стоимость занятий от 1000 рублей /60 минут</h2>
            </section>
            <section>
                <h2>Почему этот курс — то, что нужно вашему ребёнку</h2>
                <ul>
                    <li>Полная подготовка к каждому разделу экзамена</li>
                    <li>Индивидуальный подход к каждому ученику</li>
                    <li>Практические занятия с реальными КИМами</li>
                    <li>Работа над ошибками с детальным разбором</li>
                </ul>
            </section>
            <section>
                <h2>Что включает курс</h2>
                <ul>
                    <li><strong>Аудирование:</strong>
                    <ul className="sub-list">
                        <li>Тренировка восприятия речи на слух</li>
                        <li>Работа с типичными заданиями</li>
                        <li>Секреты успешного выполнения</li>
                    </ul>
                    </li>
                    <li><strong>Грамматика и лексика:</strong>
                    <ul className="sub-list">
                        <li>Отработка всех тем ЕГЭ</li>
                        <li>Устранение типичных ошибок</li>
                        <li>Специальные упражнения</li>
                    </ul>
                    </li>
                    <li><strong>Письменная речь:</strong>
                    <ul className="sub-list">
                        <li>Написание писем по готовому шаблону</li>
                        <li>Написание эссе по готовому шаблону</li>
                    </ul>
                    </li>
                    <li><strong>Говорение:</strong>
                    <ul className="sub-list">
                        <li>Подготовка к устной части</li>
                        <li>Тренировка произношения</li>
                        <li>Работа над беглостью речи</li>
                    </ul>
                    </li>
                </ul>
            </section>
            <section>
                <h2>Результаты, которые вы получите</h2>
                <ul>
                    <li>Уверенное выполнение всех заданий ЕГЭ</li>
                    <li>Понимание структуры экзамена</li>
                    <li>Владение стратегиями решения заданий</li>
                    <li>Повышение общего уровня языка</li>
                    <li>Снижение стресса перед экзаменом</li>
                </ul>
            </section>
            <section className="bonus">
                <h2>Бонусы курса</h2>
                <ul>
                    <li>Персональный план подготовки</li>
                    <li>Дополнительные материалы для практики</li>
                    <li>Пробные тестирования в формате ЕГЭ</li>
                    <li>Консультации по сложным темам</li>
                    <li>Все занятия в записи</li>
                </ul>
            </section>
            <section className="offer">
                <h2>Специальное предложение</h2>
                <ul>
                    <li>Скидка 15% на полный курс при записи сейчас</li>
                    <li>Бесплатный пробный урок</li>
                    <li>Диагностическое тестирование</li>
                </ul>
            </section>
            <section>
                <h2>Формат обучения</h2>
                <ul>
                    <li>Индивидуальные занятия</li>
                    <li>Занятия в парах</li>
                    <li>Мини-группы {'('}до 3 человек{')'}</li>
                    <li>Онлайн-формат</li>
                    <li>Гибкий график</li>
                </ul>
            </section>
            {/* <section>
                <h2>Стоимость занятий</h2>
                <div className="prices">
                    <div className="price-card" aria-label="Индивидуальное занятие 1800 рублей за 90 минут">
                    <h3>Индивидуальное занятие</h3>
                    <p><strong>1800 ₽</strong> / 90 минут</p>
                    </div>
                    <div className="price-card" aria-label="Занятие в паре 1200 рублей за 90 минут">
                    <h3>Занятие в паре</h3>
                    <p><strong>1200 ₽</strong> / 90 минут</p>
                    </div>
                    <div className="price-card" aria-label="Занятие в мини-группе 1000 рублей за 90 минут">
                    <h3>Занятие в мини-группе</h3>
                    <p><strong>1000 ₽</strong> / 90 минут</p>
                    </div>
                </div>
            </section> */}
            <section id='cta' className="cta" aria-label="Призыв к действию">
                <p><strong>Не откладывайте подготовку к ЕГЭ на последний момент!</strong></p>
                <p>Количество мест в группах ограничено.</p>
                {/* <button
                    onClick={() => window.location.href = 'tel:+79001234567'}
                    aria-label="Позвонить и записаться на курс"
                    >
                    📞 Записаться на курс прямо сейчас
                </button> */}
                <button
                    onClick={() => window.open('https://forms.gle/5MhodGWnzmw8RB9QA', '_blank')}
                    aria-label="Позвонить и записаться на курс"
                    >
                    📞 Записаться на курс прямо сейчас
                </button>
            </section>
            <section id="important" className="important-message" role="note" aria-label="Важное сообщение">
                <p><strong>ВАЖНО!</strong></p>
                <p>Ваш результат зависит не только от меня, но и лично от Вас!</p>
            </section>
        </>
    );
}
